import { Injectable, Component, Inject, HostBinding, InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReplaySubject, EMPTY, Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { concatMap, startWith, mapTo, distinctUntilChanged, tap, mergeMapTo, takeUntil } from 'rxjs/operators';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/material/dialog';
import * as ɵngcc2 from '@angular/material/button';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@angular/material/icon';
import * as ɵngcc5 from '@angular/material/snack-bar';

function NotificationBannerComponent_div_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementStart(1, "mat-icon", 10);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r87 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(notification_r87.icon);
} }
function NotificationBannerComponent_div_0_button_7_Template(rf, ctx) { if (rf & 1) {
    const _r93 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 11);
    ɵngcc0.ɵɵlistener("click", function NotificationBannerComponent_div_0_button_7_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r93); const ctx_r92 = ɵngcc0.ɵɵnextContext(2); return ctx_r92.dismiss(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r87 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", notification_r87.dismissActionLabel, " ");
} }
function NotificationBannerComponent_div_0_button_8_Template(rf, ctx) { if (rf & 1) {
    const _r96 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 12);
    ɵngcc0.ɵɵlistener("click", function NotificationBannerComponent_div_0_button_8_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r96); const ctx_r95 = ɵngcc0.ɵɵnextContext(2); return ctx_r95.submit(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r87 = ɵngcc0.ɵɵnextContext().ngIf;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", notification_r87.submitActionLabel, " ");
} }
function NotificationBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, NotificationBannerComponent_div_0_div_3_Template, 3, 1, "div", 4);
    ɵngcc0.ɵɵelementStart(4, "p", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 6);
    ɵngcc0.ɵɵtemplate(7, NotificationBannerComponent_div_0_button_7_Template, 2, 1, "button", 7);
    ɵngcc0.ɵɵtemplate(8, NotificationBannerComponent_div_0_button_8_Template, 2, 1, "button", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const notification_r87 = ctx.ngIf;
    ɵngcc0.ɵɵproperty("@flyInOut", undefined);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", notification_r87.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(notification_r87.message);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", notification_r87.dismissActionLabel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", notification_r87.submitActionLabel);
} }
class NotificationStorage {
    constructor() {
        this.notifications$ = new ReplaySubject();
    }
    ngOnDestroy() {
        this.notifications$.complete();
    }
    append(notification) {
        this.notifications$.next(notification);
    }
    get() {
        return this.notifications$.asObservable();
    }
}
NotificationStorage.ɵfac = function NotificationStorage_Factory(t) { return new (t || NotificationStorage)(); };
NotificationStorage.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationStorage, factory: NotificationStorage.ɵfac });
NotificationStorage.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationStorage, [{
        type: Injectable
    }], function () { return []; }, null); })();

var NotificationResult;
(function (NotificationResult) {
    NotificationResult[NotificationResult["DISMISSED"] = 0] = "DISMISSED";
    NotificationResult[NotificationResult["SUBMITTED"] = 1] = "SUBMITTED";
})(NotificationResult || (NotificationResult = {}));

class Notification {
    constructor(options) {
        this.result$ = new ReplaySubject(1);
        this.message = options.message;
    }
    dismiss() {
        this.result$.next(NotificationResult.DISMISSED);
        this.result$.complete();
    }
    submit() {
        this.result$.next(NotificationResult.SUBMITTED);
        this.result$.complete();
    }
    afterFinished() {
        return this.result$.asObservable();
    }
}

class HighPriorityNotification extends Notification {
    constructor(options) {
        super(options);
        this.title = options.title;
        this.dismissActionLabel = options.dismissActionLabel;
        this.submitActionLabel = options.submitActionLabel;
    }
}

class MediumPriorityNotification extends Notification {
    constructor(options) {
        super(options);
        this.submitActionLabel = options.submitActionLabel;
        this.icon = options.icon;
        this.dismissActionLabel = options.dismissActionLabel;
    }
}

class LowPriorityNotification extends Notification {
    constructor(options) {
        super(options);
        this.submitActionLabel = options.submitActionLabel;
    }
}

class NotificationService {
    constructor(storage) {
        this.storage = storage;
    }
    openLowPriority(options) {
        const notification = new LowPriorityNotification(options);
        this.storage.append(notification);
        return notification;
    }
    openMediumPriority(options) {
        const notification = new MediumPriorityNotification(options);
        this.storage.append(notification);
        return notification;
    }
    openHighPriority(options) {
        const notification = new HighPriorityNotification(options);
        this.storage.append(notification);
        return notification;
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(ɵngcc0.ɵɵinject(NotificationStorage)); };
NotificationService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationService, factory: NotificationService.ɵfac });
NotificationService.ctorParameters = () => [
    { type: NotificationStorage }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable
    }], function () { return [{ type: NotificationStorage }]; }, null); })();

class NotificationDialogComponent {
    constructor(notification) {
        this.notification = notification;
    }
}
NotificationDialogComponent.ɵfac = function NotificationDialogComponent_Factory(t) { return new (t || NotificationDialogComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA)); };
NotificationDialogComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationDialogComponent, selectors: [["ant-notification-dialog"]], decls: 9, vars: 4, consts: [["mat-dialog-title", "", 1, "notification-title"], [1, "notification-message"], [1, "notification-actions"], ["mat-button", "", "mat-dialog-close", "", 1, "notification-action", "notification-dismiss", 3, "click"], ["color", "primary", "mat-button", "", "mat-dialog-close", "", 1, "notification-action", "notification-submit", 3, "click"]], template: function NotificationDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "h1", 0);
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(2, "mat-dialog-content", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "mat-dialog-actions", 2);
        ɵngcc0.ɵɵelementStart(5, "button", 3);
        ɵngcc0.ɵɵlistener("click", function NotificationDialogComponent_Template_button_click_5_listener() { return ctx.notification.dismiss(); });
        ɵngcc0.ɵɵtext(6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 4);
        ɵngcc0.ɵɵlistener("click", function NotificationDialogComponent_Template_button_click_7_listener() { return ctx.notification.submit(); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.notification == null ? null : ctx.notification.title);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ctx.notification == null ? null : ctx.notification.message);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.notification == null ? null : ctx.notification.dismissActionLabel, " ");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.notification == null ? null : ctx.notification.submitActionLabel, " ");
    } }, directives: [ɵngcc1.MatDialogTitle, ɵngcc1.MatDialogContent, ɵngcc1.MatDialogActions, ɵngcc2.MatButton, ɵngcc1.MatDialogClose], styles: [".notification-actions[_ngcontent-%COMP%]{display:flex;justify-content:flex-end}"] });
NotificationDialogComponent.ctorParameters = () => [
    { type: HighPriorityNotification, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationDialogComponent, [{
        type: Component,
        args: [{
                selector: 'ant-notification-dialog',
                template: "<h1 mat-dialog-title class=\"notification-title\">{{ notification?.title }}</h1>\n<mat-dialog-content class=\"notification-message\">{{ notification?.message }}</mat-dialog-content>\n<mat-dialog-actions class=\"notification-actions\">\n  <button (click)=\"notification.dismiss()\"\n          class=\"notification-action notification-dismiss\"\n          mat-button\n          mat-dialog-close\n  >\n    {{ notification?.dismissActionLabel }}\n  </button>\n  <button (click)=\"notification.submit()\"\n          class=\"notification-action notification-submit\"\n          color=\"primary\"\n          mat-button\n          mat-dialog-close\n  >\n    {{ notification?.submitActionLabel }}\n  </button>\n</mat-dialog-actions>\n",
                styles: [".notification-actions{display:flex;justify-content:flex-end}"]
            }]
    }], function () { return [{ type: HighPriorityNotification, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }]; }, null); })();

class NotificationHandler {
}

class MidPriorityNotificationHandler extends NotificationHandler {
    constructor() {
        super();
        this.currentNotification$ = new ReplaySubject(1);
    }
    handle(notification) {
        this.currentNotification$.next(notification);
        return EMPTY;
    }
    getCurrentNotification() {
        return this.currentNotification$.pipe(concatMap(notification => notification.afterFinished().pipe(startWith({}), mapTo(notification))), distinctUntilChanged());
    }
}
MidPriorityNotificationHandler.ɵfac = function MidPriorityNotificationHandler_Factory(t) { return new (t || MidPriorityNotificationHandler)(); };
MidPriorityNotificationHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: MidPriorityNotificationHandler, factory: MidPriorityNotificationHandler.ɵfac });
MidPriorityNotificationHandler.ctorParameters = () => [];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(MidPriorityNotificationHandler, [{
        type: Injectable
    }], function () { return []; }, null); })();

class NotificationBannerComponent {
    constructor(notificationProvider) {
        this.antNotificationBannerClass = true;
        this.antNotificationBannerAnimation = true;
        this.currentNotification = undefined;
        notificationProvider.getCurrentNotification().subscribe(notification => this.currentNotification = notification);
    }
    submit() {
        if (!this.currentNotification) {
            return;
        }
        const notification = this.currentNotification;
        this.currentNotification = undefined;
        notification.submit();
    }
    dismiss() {
        if (!this.currentNotification) {
            return;
        }
        const notification = this.currentNotification;
        this.currentNotification = undefined;
        notification.dismiss();
    }
}
NotificationBannerComponent.ɵfac = function NotificationBannerComponent_Factory(t) { return new (t || NotificationBannerComponent)(ɵngcc0.ɵɵdirectiveInject(MidPriorityNotificationHandler)); };
NotificationBannerComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NotificationBannerComponent, selectors: [["ant-notification-banner"]], hostVars: 3, hostBindings: function NotificationBannerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵupdateSyntheticHostBinding("@flyInOut", ctx.antNotificationBannerAnimation);
        ɵngcc0.ɵɵclassProp("ant-notification-banner", ctx.antNotificationBannerClass);
    } }, decls: 1, vars: 1, consts: [["class", "ant-notification-banner-wrapper", 4, "ngIf"], [1, "ant-notification-banner-wrapper"], [1, "ant-notification-banner-inner"], [1, "notification-content"], ["class", "notification-icon-holder", 4, "ngIf"], [1, "notification-message", "mat-body"], [1, "notification-actions"], ["class", "notification-action notification-dismiss", "color", "primary", "mat-button", "", "dense", "", 3, "click", 4, "ngIf"], ["class", "notification-action notification-submit", "color", "primary", "mat-button", "", "dense", "", 3, "click", 4, "ngIf"], [1, "notification-icon-holder"], [1, "notification-icon"], ["color", "primary", "mat-button", "", "dense", "", 1, "notification-action", "notification-dismiss", 3, "click"], ["color", "primary", "mat-button", "", "dense", "", 1, "notification-action", "notification-submit", 3, "click"]], template: function NotificationBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NotificationBannerComponent_div_0_Template, 9, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.currentNotification);
    } }, directives: [ɵngcc3.NgIf, ɵngcc4.MatIcon, ɵngcc2.MatButton], styles: ["*[_ngcontent-%COMP%]{transition:all .2s ease-in-out}[_nghost-%COMP%]{display:block;overflow:hidden;position:-webkit-sticky;position:sticky;top:0}.ant-notification-banner-wrapper[_ngcontent-%COMP%], [_nghost-%COMP%]{max-width:100%;width:100%}.ant-notification-banner-inner[_ngcontent-%COMP%]{align-items:center;box-sizing:border-box;display:flex;flex-flow:row wrap;justify-content:flex-start;padding:.625rem 0 .5rem}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-content[_ngcontent-%COMP%]{align-items:flex-start;display:flex;justify-content:flex-start;margin:.5rem 0}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-content[_ngcontent-%COMP%]   .notification-icon-holder[_ngcontent-%COMP%]{border-radius:50%;box-sizing:border-box;height:2.5rem;margin-left:1rem;padding:.5rem;width:2.5rem}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-content[_ngcontent-%COMP%]   .notification-message[_ngcontent-%COMP%]{flex:1 auto;margin:0 .5rem 0 1rem}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-actions[_ngcontent-%COMP%]{box-sizing:border-box;display:flex;flex:1 auto;justify-content:flex-end;margin-left:2.25rem}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-actions[_ngcontent-%COMP%]   .notification-action[_ngcontent-%COMP%]{height:2.25rem;margin-right:.5rem}@media screen and (min-width:720px){.ant-notification-banner-inner[_ngcontent-%COMP%]{flex-wrap:nowrap}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-content[_ngcontent-%COMP%]   .notification-message[_ngcontent-%COMP%]{margin-left:1.5rem;margin-right:5.625rem}.ant-notification-banner-inner[_ngcontent-%COMP%]   .notification-actions[_ngcontent-%COMP%]{align-self:flex-end}}"], data: { animation: [
            trigger('flyInOut', [
                state('in', style({
                    transform: 'translateY(0) translateZ(0)',
                    opacity: 1
                })),
                transition(':enter', [
                    style({
                        transform: 'translateY(-100%) translateZ(-50px)',
                        opacity: 0
                    }),
                    animate(200)
                ]),
                transition(':leave', [
                    animate(200),
                    style({
                        transform: 'translateY(-100%) translateZ(-50px)',
                        opacity: 0
                    })
                ])
            ])
        ] } });
NotificationBannerComponent.ctorParameters = () => [
    { type: MidPriorityNotificationHandler }
];
NotificationBannerComponent.propDecorators = {
    antNotificationBannerClass: [{ type: HostBinding, args: ['class.ant-notification-banner',] }],
    antNotificationBannerAnimation: [{ type: HostBinding, args: ['@flyInOut',] }]
};
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ant-notification-banner',
                template: "<div class=\"ant-notification-banner-wrapper\" *ngIf=\"currentNotification as notification\" @flyInOut>\n  <div class=\"ant-notification-banner-inner\">\n    <div class=\"notification-content\">\n      <div *ngIf=\"notification.icon\" class=\"notification-icon-holder\">\n        <mat-icon class=\"notification-icon\">{{ notification.icon }}</mat-icon>\n      </div>\n      <p class=\"notification-message mat-body\">{{ notification.message }}</p>\n    </div>\n    <div class=\"notification-actions\">\n      <button (click)=\"dismiss()\"\n              *ngIf=\"notification.dismissActionLabel\"\n              class=\"notification-action notification-dismiss\"\n              color=\"primary\"\n              mat-button\n              dense\n      >\n        {{ notification.dismissActionLabel }}\n      </button>\n      <button (click)=\"submit()\"\n              *ngIf=\"notification.submitActionLabel\"\n              class=\"notification-action notification-submit\"\n              color=\"primary\"\n              mat-button\n              dense\n      >\n        {{ notification.submitActionLabel }}\n      </button>\n    </div>\n  </div>\n</div>\n",
                animations: [
                    trigger('flyInOut', [
                        state('in', style({
                            transform: 'translateY(0) translateZ(0)',
                            opacity: 1
                        })),
                        transition(':enter', [
                            style({
                                transform: 'translateY(-100%) translateZ(-50px)',
                                opacity: 0
                            }),
                            animate(200)
                        ]),
                        transition(':leave', [
                            animate(200),
                            style({
                                transform: 'translateY(-100%) translateZ(-50px)',
                                opacity: 0
                            })
                        ])
                    ])
                ],
                styles: ["*{transition:all .2s ease-in-out}:host{display:block;overflow:hidden;position:-webkit-sticky;position:sticky;top:0}.ant-notification-banner-wrapper,:host{max-width:100%;width:100%}.ant-notification-banner-inner{align-items:center;box-sizing:border-box;display:flex;flex-flow:row wrap;justify-content:flex-start;padding:.625rem 0 .5rem}.ant-notification-banner-inner .notification-content{align-items:flex-start;display:flex;justify-content:flex-start;margin:.5rem 0}.ant-notification-banner-inner .notification-content .notification-icon-holder{border-radius:50%;box-sizing:border-box;height:2.5rem;margin-left:1rem;padding:.5rem;width:2.5rem}.ant-notification-banner-inner .notification-content .notification-message{flex:1 auto;margin:0 .5rem 0 1rem}.ant-notification-banner-inner .notification-actions{box-sizing:border-box;display:flex;flex:1 auto;justify-content:flex-end;margin-left:2.25rem}.ant-notification-banner-inner .notification-actions .notification-action{height:2.25rem;margin-right:.5rem}@media screen and (min-width:720px){.ant-notification-banner-inner{flex-wrap:nowrap}.ant-notification-banner-inner .notification-content .notification-message{margin-left:1.5rem;margin-right:5.625rem}.ant-notification-banner-inner .notification-actions{align-self:flex-end}}"]
            }]
    }], function () { return [{ type: MidPriorityNotificationHandler }]; }, { antNotificationBannerClass: [{
            type: HostBinding,
            args: ['class.ant-notification-banner']
        }], antNotificationBannerAnimation: [{
            type: HostBinding,
            args: ['@flyInOut']
        }] }); })();

const LOW_PRIORITY_CONFIG = new InjectionToken('ant_core.notifications.low_priority_config');
const LOW_PRIORITY_DEFAULT_CONFIG = {
    duration: 2000
};

class LowPriorityNotificationHandler extends NotificationHandler {
    constructor(config, matSnackBar) {
        super();
        this.config = config;
        this.matSnackBar = matSnackBar;
    }
    handle(notification) {
        const snackbar = this.getSnackBarRef(notification);
        const snackbarDismissed = snackbar.afterDismissed();
        return snackbarDismissed.pipe(tap(snackBarResult => this.handleSnackbarResult(snackBarResult, notification)), mergeMapTo(notification.afterFinished()), mapTo(undefined));
    }
    getSnackBarRef(notification) {
        return this.matSnackBar.open(notification.message, notification.submitActionLabel, {
            duration: this.config.duration
        });
    }
    handleSnackbarResult(snackbarDismiss, notification) {
        if (snackbarDismiss.dismissedByAction) {
            notification.submit();
        }
        else {
            notification.dismiss();
        }
    }
}
LowPriorityNotificationHandler.ɵfac = function LowPriorityNotificationHandler_Factory(t) { return new (t || LowPriorityNotificationHandler)(ɵngcc0.ɵɵinject(LOW_PRIORITY_CONFIG), ɵngcc0.ɵɵinject(ɵngcc5.MatSnackBar)); };
LowPriorityNotificationHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: LowPriorityNotificationHandler, factory: LowPriorityNotificationHandler.ɵfac });
LowPriorityNotificationHandler.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [LOW_PRIORITY_CONFIG,] }] },
    { type: MatSnackBar }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(LowPriorityNotificationHandler, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [LOW_PRIORITY_CONFIG]
            }] }, { type: ɵngcc5.MatSnackBar }]; }, null); })();

class HighPriorityNotificationHandler extends NotificationHandler {
    constructor(matDialog) {
        super();
        this.matDialog = matDialog;
    }
    handle(notification) {
        return this.matDialog.open(NotificationDialogComponent, {
            data: notification
        }).afterClosed();
    }
}
HighPriorityNotificationHandler.ɵfac = function HighPriorityNotificationHandler_Factory(t) { return new (t || HighPriorityNotificationHandler)(ɵngcc0.ɵɵinject(ɵngcc1.MatDialog)); };
HighPriorityNotificationHandler.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: HighPriorityNotificationHandler, factory: HighPriorityNotificationHandler.ɵfac });
HighPriorityNotificationHandler.ctorParameters = () => [
    { type: MatDialog }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(HighPriorityNotificationHandler, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.MatDialog }]; }, null); })();

class UnknownNotificationPriorityError extends Error {
    constructor() {
        super('Unknown NotificationPriority');
    }
}

class NotificationHandlerService {
    constructor(highPrioHandler, midPrioHandler, lowPrioHandler) {
        this.highPrioHandler = highPrioHandler;
        this.midPrioHandler = midPrioHandler;
        this.lowPrioHandler = lowPrioHandler;
    }
    handle(notification) {
        const handler = this.getHandlerForNotification(notification);
        return handler.handle(notification);
    }
    getHandlerForNotification(notification) {
        if (notification instanceof HighPriorityNotification) {
            return this.highPrioHandler;
        }
        else if (notification instanceof MediumPriorityNotification) {
            return this.midPrioHandler;
        }
        else if (notification instanceof LowPriorityNotification) {
            return this.lowPrioHandler;
        }
        throw new UnknownNotificationPriorityError();
    }
}
NotificationHandlerService.ɵfac = function NotificationHandlerService_Factory(t) { return new (t || NotificationHandlerService)(ɵngcc0.ɵɵinject(HighPriorityNotificationHandler), ɵngcc0.ɵɵinject(MidPriorityNotificationHandler), ɵngcc0.ɵɵinject(LowPriorityNotificationHandler)); };
NotificationHandlerService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationHandlerService, factory: NotificationHandlerService.ɵfac });
NotificationHandlerService.ctorParameters = () => [
    { type: HighPriorityNotificationHandler },
    { type: MidPriorityNotificationHandler },
    { type: LowPriorityNotificationHandler }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationHandlerService, [{
        type: Injectable
    }], function () { return [{ type: HighPriorityNotificationHandler }, { type: MidPriorityNotificationHandler }, { type: LowPriorityNotificationHandler }]; }, null); })();

class NotificationLoaderService {
    constructor(storage, handler) {
        this.storage = storage;
        this.handler = handler;
        this.destroyed$ = new Subject();
    }
    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }
    init() {
        this.storage.get().pipe(takeUntil(this.destroyed$), concatMap((notification) => this.handler.handle(notification))).subscribe();
    }
}
NotificationLoaderService.ɵfac = function NotificationLoaderService_Factory(t) { return new (t || NotificationLoaderService)(ɵngcc0.ɵɵinject(NotificationStorage), ɵngcc0.ɵɵinject(NotificationHandlerService)); };
NotificationLoaderService.ɵprov = ɵngcc0.ɵɵdefineInjectable({ token: NotificationLoaderService, factory: NotificationLoaderService.ɵfac });
NotificationLoaderService.ctorParameters = () => [
    { type: NotificationStorage },
    { type: NotificationHandlerService }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(NotificationLoaderService, [{
        type: Injectable
    }], function () { return [{ type: NotificationStorage }, { type: NotificationHandlerService }]; }, null); })();

const MEDIUM_PRIORITY_CONFIG = new InjectionToken('ant_core.notifications.medium_priority_config');
const MEDIUM_PRIORITY_DEFAULT_CONFIG = {};

const HIGH_PRIORITY_CONFIG = new InjectionToken('ant_core.notifications.high_priority_config');
const HIGH_PRIORITY_DEFAULT_CONFIG = {};

class ConfigBuilder {
    static buildConfig(config = {}) {
        return Object.assign(Object.assign({}, config), { lowPriorityConfig: ConfigBuilder.buildLowPrioConfig(config.lowPriorityConfig), mediumPriorityConfig: ConfigBuilder.buildMediumPrioConfig(config.mediumPriorityConfig), highPriorityConfig: ConfigBuilder.buildHighPrioConfig(config.highPriorityConfig), lowPriorityHandler: config.lowPriorityHandler || LowPriorityNotificationHandler, mediumPriorityHandler: config.mediumPriorityHandler || MidPriorityNotificationHandler, highPriorityHandler: config.highPriorityHandler || HighPriorityNotificationHandler });
    }
    static buildLowPrioConfig(config = {}) {
        return Object.assign(Object.assign({}, LOW_PRIORITY_DEFAULT_CONFIG), config);
    }
    static buildMediumPrioConfig(config = {}) {
        return Object.assign(Object.assign({}, MEDIUM_PRIORITY_DEFAULT_CONFIG), config);
    }
    static buildHighPrioConfig(config = {}) {
        return Object.assign(Object.assign({}, HIGH_PRIORITY_DEFAULT_CONFIG), config);
    }
}

class AntNotificationModule {
    constructor(loader) {
        loader.init();
    }
    static forRoot(config = {}) {
        config = ConfigBuilder.buildConfig(config);
        return {
            ngModule: AntNotificationModule,
            providers: [
                { provide: LOW_PRIORITY_CONFIG, useValue: config.lowPriorityConfig },
                { provide: LowPriorityNotificationHandler, useClass: config.lowPriorityHandler },
                { provide: MEDIUM_PRIORITY_CONFIG, useValue: config.mediumPriorityConfig },
                { provide: MidPriorityNotificationHandler, useClass: config.mediumPriorityHandler },
                { provide: HIGH_PRIORITY_CONFIG, useValue: config.highPriorityConfig },
                { provide: HighPriorityNotificationHandler, useClass: config.highPriorityHandler }
            ]
        };
    }
}
AntNotificationModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: AntNotificationModule });
AntNotificationModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function AntNotificationModule_Factory(t) { return new (t || AntNotificationModule)(ɵngcc0.ɵɵinject(NotificationLoaderService)); }, providers: [
        NotificationStorage,
        NotificationLoaderService,
        NotificationHandlerService,
        NotificationService
    ], imports: [[
            CommonModule,
            MatButtonModule,
            MatCardModule,
            MatDialogModule,
            MatIconModule,
            MatSnackBarModule
        ]] });
AntNotificationModule.ctorParameters = () => [
    { type: NotificationLoaderService }
];
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(AntNotificationModule, { declarations: function () { return [NotificationDialogComponent,
        NotificationBannerComponent]; }, imports: function () { return [CommonModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        MatSnackBarModule]; }, exports: function () { return [NotificationBannerComponent]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AntNotificationModule, [{
        type: NgModule,
        args: [{
                declarations: [
                    NotificationDialogComponent,
                    NotificationBannerComponent
                ],
                imports: [
                    CommonModule,
                    MatButtonModule,
                    MatCardModule,
                    MatDialogModule,
                    MatIconModule,
                    MatSnackBarModule
                ],
                providers: [
                    NotificationStorage,
                    NotificationLoaderService,
                    NotificationHandlerService,
                    NotificationService
                ],
                exports: [
                    NotificationBannerComponent
                ]
            }]
    }], function () { return [{ type: NotificationLoaderService }]; }, null); })();

/*
 * Public API Surface of ant-core
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AntNotificationModule, HighPriorityNotification, HighPriorityNotificationHandler, LowPriorityNotification, LowPriorityNotificationHandler, MediumPriorityNotification, MidPriorityNotificationHandler, Notification, NotificationBannerComponent, NotificationHandler, NotificationResult, NotificationService, NotificationStorage, NotificationDialogComponent as ɵa, NotificationLoaderService as ɵb, NotificationHandlerService as ɵc, LOW_PRIORITY_CONFIG as ɵd };

//# sourceMappingURL=antony-core.js.map